import { rem } from 'polished';
import styled from 'styled-components';

const ColorModalTitleContainer = styled.div`
    margin-bottom: ${rem(8)};
    padding-right: ${rem(16)};
    position: relative;
`;

export default ColorModalTitleContainer;
